import { combineReducers } from '@reduxjs/toolkit';
import championshipTeamsReducer from './championshipTeams';

const teamsReducer = combineReducers({
  championshipTeams: championshipTeamsReducer
});

export default teamsReducer;
